export default {
  games: [
    {
      'id': 0,
      'img': '../static/img/shots/p23.jpg',
      'gif': '../static/img/shots/prophour23.gif',
      'game': 'Prophour23',
      'description': 'A fast paced real-time strategy with unique theme.',
      'urls': ['http://store.steampowered.com/app/317610/Prophour23/', 'https://thotep.itch.io/prophour23', 'https://play.google.com/store/apps/details?id=com.thesecretpie.prophour23.android'],
      'width': 1920,
      'height': 1080,
      'year': 2014,
      'authors': ['thotep'],
      'platforms': ['steam', 'itch', 'android']
    },
    {
      'id': 1,
      'img': '../static/img/shots/borstal.jpg',
      'gif': '../static/img/shots/borstal.gif',
      'game': 'Borstal',
      'description': 'Survival roguelike novellas.',
      'urls': ['http://store.steampowered.com/app/453730/Borstal/', 'https://thotep.itch.io/borstal', 'https://play.google.com/store/apps/details?id=com.thesecretpie.borstalfull'],
      'width': 1271,
      'height': 717,
      'year': 2016,
      'authors': ['thotep'],
      'platforms': ['steam', 'itch', 'android']
    },
    {
      'id': 2,
      'img': '../static/img/shots/hpl.jpg',
      'gif': '../static/img/shots/hpl.gif',
      'game': 'Howard Phillips Lovecar',
      'description': 'It\'s like GTA1 + Devil Daggers. Stop The Great Old Ones - or die trying!',
      'urls': ['http://store.steampowered.com/app/644370/Howard_Phillips_Lovecar/'],
      'width': 1920,
      'height': 1016,
      'year': 2017,
      'authors': ['thotep'],
      'platforms': ['steam']
    },
    {
      'id': 3,
      'img': '../static/img/shots/grandpastable.jpg',
      'gif': '../static/img/shots/grandpastable.gif',
      'game': 'Grandpa\'s Table',
      'description': 'Relaxing logic game with beautiful 3d graphics and more than one hundred and fifty levels!',
      'urls': ['http://store.steampowered.com/app/471570/Grandpas_Table/', 'https://kivano.itch.io/grandpas-table', 'https://play.google.com/store/apps/details?id=net.kivano.grandpatable.androidhd'],
      'width': 1920,
      'height': 1080,
      'year': 2013,
      'company': 'Kivano',
      'authors': ['rejke', 'kubecz3k'],
      'platforms': ['steam', 'itch', 'android', 'ios']
    },
    /* {
      'id': 5,
      'img': '../static/img/shots/hpl.gif',
      'game': 'Howard Phillips Lovecar',
      'description': 'It\'s like GTA1 + Devil Daggers. Stop The Great Old Ones - or die trying!',
      'urls': ['http://store.steampowered.com/app/644370/Howard_Phillips_Lovecar/'],
      'width': 512,
      'height': 512,
      'year': 2017,
      'authors': ['thotep'],
      'platforms': ['steam']
    },
    {
      'id': 6,
      'img': '../static/img/shots/yiqi.jpg',
      'game': 'Yi Qi',
      'description': 'A 2d platfomer about family life in the Late Jurassic period.',
      'urls': ['https://kurki-collective.itch.io/yi-qi'],
      'width': 1920,
      'height': 1080,
      'year': 2017,
      'authors': ['Miro_TREX', 'Mortalo_TREX'],
      'company': 'T-Rex Interactive',
      'platforms': ['itch']
    },
    {
      'id': 7,
      'img': '../static/img/shots/cooking_ninjas.jpg',
      'game': 'Cooking Ninjas',
      'description': 'Hotline Miami vs Overcooked! Steal ingredients and don\'t get caught.',
      'urls': ['https://kurki-collective.itch.io/cooking-ninjas'],
      'width': 919,
      'height': 637,
      'year': 2017,
      'authors': ['aadekk_'],
      'platforms': ['itch']
    }, */
    {
      'id': 8,
      'img': '../static/img/shots/marblemachine.jpg',
      'gif': '../static/img/shots/marblemachine.gif',
      'game': 'Marble Machine',
      'description': 'Experiment and solve over a hundred physic based puzzles!',
      'urls': ['https://play.google.com/store/apps/details?id=net.kivano.marblemachine'],
      'width': 1280,
      'height': 720,
      'year': 2016,
      'company': 'Kivano',
      'authors': ['rejke', 'kubecz3k'],
      'platforms': ['android']
    },
    /* {
      'id': 9,
      'img': '../static/img/shots/skullstone.jpg',
      'gif': '../static/img/shots/skullstone.gif',
      'game': 'Skullstone',
      'description': 'An old-styled dungeon crawler game with modern 3D graphics.',
      'urls': ['http://skullstonegame.com/', 'https://steamcommunity.com/sharedfiles/filedetails/?id=870575498'],
      'width': 1600,
      'height': 900,
      'year': 2018,
      'authors': ['skullstonegame'],
      'platforms': ['page', 'steam']
    }, */
    {
      'id': 10,
      'img': '../static/img/shots/fit2shapes.jpg',
      'gif': '../static/img/shots/fit2shapes.gif',
      'game': 'Fit2Shapes',
      'description': 'Innovative puzzle-arcade game, where you need to match figure for pattern by tapping screen in the right time.',
      'urls': ['https://play.google.com/store/apps/details?id=com.StudioGier.Fit2Shapes'],
      'width': 506,
      'height': 900,
      'year': 2017,
      'authors': ['aadekk_'],
      'company': ['Studio Gier'],
      'platforms': ['android']
    },
    {
      'id': 11,
      'img': '../static/img/shots/popClop.jpg',
      'gif': '../static/img/shots/popClop.gif',
      'game': 'Pop Clop',
      'description': 'Easy to learn, but hard to master arcade game, where you need to throw objects like darts, calipers, screwdriver etc. directly into flying balloons.',
      'urls': ['https://play.google.com/store/apps/details?id=com.StudioGier.PopClop'],
      'width': 506,
      'height': 900,
      'year': 2016,
      'authors': ['aadekk_'],
      'company': ['Studio Gier'],
      'platforms': ['android']
    },
    {
      'id': 13,
      'img': '../static/img/shots/boxkid.jpg',
      'gif': '../static/img/shots/boxkid.gif',
      'game': 'Box Kid Adventures',
      'description': '2D top down game, full of nasty enemies and brain challenging puzzles.',
      'urls': ['https://steamcommunity.com/sharedfiles/filedetails/?id=509854181', 'http://boxkidadventures.com/'],
      'width': 1920,
      'height': 1080,
      'year': 2018,
      'authors': ['Miro_TREX', 'Mortalo_TREX'],
      'company': 'T-Rex Interactive',
      'platforms': ['steam', 'page']
    },
    {
      'id': 14,
      'img': '../static/img/shots/ERscreen.jpg',
      'gif': '../static/img/shots/ERLogoAnim.gif',
      'game': 'Electro Ride',
      'description': "Electro Ride is a Neon-lighted Arcade Racing game with colorful boost zones, color switching and '80 legendary cars.",
      'urls': ['https://steamcommunity.com/sharedfiles/filedetails/?id=909312737'],
      'width': 1226,
      'height': 690,
      'year': 2019,
      'authors': ['SylwesterOsik'],
      'platforms': ['steam']
    },
    {
      'id': 15,
      'img': '../static/img/shots/zniwadventure.jpg',
      'gif': '../static/img/shots/zniwadventure.gif',
      'game': 'Zniw Adventure',
      'description': "A prehistoric point 'n click adventure for the entire family.",
      'urls': ['https://store.steampowered.com/app/904750/Zniw_Adventure/', 'https://discordapp.com/invite/9ydTfhq', 'https://www.facebook.com/zniwadventure'],
      'width': 1280,
      'height': 960,
      'authors': ['kurasiupl', 'twarda8'],
      'platforms': ['steam', 'discord', 'page']
    },
    {
      'img': '../static/img/shots/TailQuest.jpg',
      'gif': '../static/img/shots/TailQuest.mp4',
      'game': 'TailQuest',
      'description': 'TailQuest is an unique mix of tower defense and 3D puzzle platformer. Join Nell as he tries to defend a vivid world from an invasion of colorful robots. ',
      'urls': ['https://store.steampowered.com/app/824090/TailQuest_Defense/', 'https://www.kivano.games', 'https://discord.gg/dYJVNQb'],
      'width': 1680,
      'height': 1018,
      'year': 2020,
      'company': 'Kivano',
      'authors': ['rejke', 'kubecz3k'],
      'platforms': ['steam', 'page', 'discord']
    },
    {
      'img': '../static/img/shots/delta-v.jpg',
      'gif': '../static/img/shots/delta-v.mp4',
      'game': 'ΔV: Rings of Saturn',
      'description': 'Realistic top-down space simulator',
      'urls': ['https://store.steampowered.com/app/846030/V_Rings_of_Saturn/?utm_source=kurki&utm_campagin=kurki.games', 'https://koder.itch.io/dv-rings-of-saturn', 'https://discord.gg/dv'],
      'width': 1920,
      'height': 1080,
      'year': 2020,
      'authors': ['KoderaSoftware'],
      'platforms': ['steam', 'itch', 'discord']
    },
    {
      'img': '../static/img/shots/mars.jpg',
      'gif': '../static/img/shots/mars.gif',
      'game': 'Mars Power Industries Deluxe',
      'description': 'A fast paced real-time strategy with unique theme.',
      'urls': ['https://store.steampowered.com/app/977230/Mars_Power_Industries_Deluxe/', 'https://itunes.apple.com/app/mars-power-industries/id1380742537', 'https://play.google.com/store/apps/details?id=com.sevenagames.marspuzzle', 'https://www.microsoft.com/p/mars-power-industries-deluxe/9nkt9q7vzj69', 'https://www.nintendo.com/games/detail/mars-power-industries-switch/'],
      'width': 1920,
      'height': 1080,
      'year': 2018,
      'authors': ['lukz_dev'],
      'platforms': ['steam', 'ios', 'android', 'xbox', 'switch']
    },
    {
      'img': '../static/img/shots/livingstone.jpg',
      'gif': '../static/img/shots/livingstone.gif',
      'game': 'Dr Livingstone, I Presume?',
      'description': 'As Henry Stanley, you came to Africa to find the missing Dr Livingstone. Explore a mysterious building full of closed doors and unusual objects and solve puzzles to achieve your goal.',
      'urls': ['https://store.steampowered.com/app/1237510/Dr_Livingstone_I_Presume/'],
      'width': 1920,
      'height': 1080,
      'year': 2021,
      'authors': ['Livi_TheGame'],
      'platforms': ['steam']
    }
  ],
  members: [
    {
      'name': 'Iza',
      'twitter': 'rejke',
      'img': '../static/img/members/rejke.jpg'
    },
    {
      'name': 'Kuba',
      'twitter': 'kubecz3k',
      'img': '../static/img/members/kuba.jpg'
    },
    {
      'name': 'Przemek',
      'twitter': 'thotep',
      'img': '../static/img/members/thotep.jpg'
    },
    {
      'name': 'Adrian',
      'twitter': 'aadekk_',
      'img': '../static/img/members/adek.jpg'
    },
    {
      'name': 'Łukasz',
      'twitter': 'lukz_dev',
      'img': '../static/img/members/lukz_dev.jpg'
    },
    {
      'name': 'Marcin',
      'twitter': 'vigrid',
      'img': '../static/img/members/vigrid.jpg'
    },
    {
      'name': 'Filip',
      'twitter': 'filiploster',
      'img': '../static/img/members/aare.jpg'
    },
    {
      'name': 'Mirek',
      'twitter': 'Miro_TREX',
      'img': '../static/img/members/miro.jpg'
    },
    {
      'name': 'Sebastian',
      'twitter': 'Mortalo_TREX',
      'img': '../static/img/members/mortalo.jpg'
    },
    {
      'name': 'Sylwester',
      'twitter': 'SylwesterOsik',
      'img': '../static/img/members/SylwesterOsik.jpg'
    },
    {
      'name': 'Łukasz',
      'twitter': 'kurasiupl',
      'img': '../static/img/members/crash.jpg'
    },
    {
      'name': 'Karolina',
      'twitter': 'twarda8',
      'img': '../static/img/members/twarda.jpg'
    },
    {
      'name': 'Mariusz',
      'twitter': 'KoderaSoftware',
      'img': '../static/img/members/koder.jpg'
    },
    {
      'name': 'Kamil',
      'twitter': 'Livi_TheGame',
      'img': '../static/img/members/Livi_TheGame.jpg'
    }
  ],
  platforms: {
    'steam': 'Get it on Steam',
    'itch': 'Get it on itch.io',
    'android': 'Get it on Google Play',
    'ios': 'Get it on App Store',
    'page': 'Visit the game\'s page',
    'discord': 'Join the game\'s Discord',
    'xbox': 'Get it on Xbox',
    'switch': 'Get it on Switch'
  }
}



// WEBPACK FOOTER //
// ./src/data.js